// extracted by mini-css-extract-plugin
module.exports = {"feedbackwrap":"FeedBackLink_feedbackwrap__2kO5l","textrotate":"FeedBackLink_textrotate__IcltX"};